import { adminCall, adminGet } from './adminCall';

export async function getComingSoonMode() {
  return adminGet('/api/admin/platform/coming-soon');
}

export async function setComingSoonMode({ enabled, accessCode }) {
  const payload = { enabled };
  if (typeof accessCode === 'string' && accessCode.trim()) {
    payload.accessCode = accessCode.trim();
  }
  const data = await adminCall('/api/admin/platform/coming-soon', payload);
  if (!data?.success && data?.enabled == null) {
    throw new Error(data?.error || 'Failed to update coming soon settings');
  }
  return data;
}

export async function getAppMaintenanceMode() {
  return adminGet('/api/admin/platform/maintenance');
}

export async function setAppMaintenanceMode({ enabled, scheduledStartTime } = {}) {
  const payload = {};
  if (enabled !== undefined) payload.enabled = enabled;
  if (scheduledStartTime !== undefined) payload.scheduledStartTime = scheduledStartTime;
  const data = await adminCall('/api/admin/platform/maintenance', payload);
  if (!data?.success && data?.enabled == null) {
    throw new Error(data?.error || 'Failed to update maintenance settings');
  }
  return data;
}

export async function getWebsiteMaintenanceMode() {
  return adminGet('/api/admin/platform/website-maintenance');
}

export async function setWebsiteMaintenanceMode({ enabled }) {
  const data = await adminCall('/api/admin/platform/website-maintenance', { enabled });
  if (!data?.success && data?.enabled == null) {
    throw new Error(data?.error || 'Failed to update website maintenance');
  }
  return data;
}

export async function getAdminGateMode() {
  return adminGet('/api/admin/platform/admin-gate');
}

export async function setAdminGateMode({ accessCode, enabled } = {}) {
  const payload = {};
  if (typeof accessCode === 'string' && accessCode.trim()) {
    payload.accessCode = accessCode.trim();
  }
  if (typeof enabled === 'boolean') {
    payload.enabled = enabled;
  }
  const data = await adminCall('/api/admin/platform/admin-gate', payload);
  if (!data?.success && data?.required == null) {
    throw new Error(data?.error || 'Failed to update admin access code');
  }
  return data;
}
